import instance from '@apis/instance';
import {
    AddToCartRequest, AddToCartResponse, CartIdResponse, CartResponse, UpdateCartQuantityRequest,
} from '@models/cart';

class CartApi {
    static addToCart(shopId: string, request: AddToCartRequest): Promise<AddToCartResponse> {
        return instance.post(`/shop/${shopId}/cart/item`, request);
    }

    static getCart(shopId: string, cartId: string): Promise<CartResponse> {
        return instance.get(`/shop/${shopId}/cart/${cartId}`);
    }

    static getCartIdByShopId(shopId: string): Promise<CartIdResponse> {
        return instance.get(`/shop/${shopId}/cart`);
    }

    static updateCartItemQuantity(
        shopId: string,
        cartId: string,
        cartItemId: string,
        request: UpdateCartQuantityRequest,
    ): Promise<unknown> {
        return instance.patch(`/shop/${shopId}/cart/${cartId}/item/${cartItemId}/qty`, request);
    }

    static deleteCartItem(shopId: string, cartId: string, cartItemId: string): Promise<unknown> {
        return instance.delete(`/shop/${shopId}/cart/${cartId}/item/${cartItemId}`);
    // return Promise.resolve({});
    }
}

export default CartApi;
